import React from 'react';
import { Select, SelectOption, SelectProps } from '@indigo-ag/component-module';
import { useQuery } from '@apollo/client';
import { FinancingUser } from '@indigo-ag/schema';

import { getAllCreditAnalysts } from '../../../features/admin/adminQueries';
import { UserUtil } from '../../utils';

export interface CreditAnalystSelectorProps {
  initialOptions?: SelectOption[];
  label?: string;
  onChange?: SelectProps['onChange'];
  placeholder?: string;
  preSelectedAnalystId?: string;
}

export const CreditAnalystSelector: React.FunctionComponent<CreditAnalystSelectorProps> = ({
  initialOptions,
  label,
  onChange,
  placeholder,
  preSelectedAnalystId
}) => {
  const { data: creditAnalystsData } = useQuery<{ getAllCreditAnalysts: FinancingUser[] }>(getAllCreditAnalysts);
  const creditAnalystsList: SelectOption[] =
    creditAnalystsData?.getAllCreditAnalysts.map(creditAnalyst => ({
      name: UserUtil.getUserFullName(creditAnalyst),
      value: creditAnalyst.id
    })) || [];
  if (initialOptions?.length) {
    creditAnalystsList.unshift(...initialOptions);
  }

  return (
    <Select
      disableNative
      label={label || ''}
      name="optionsList"
      onChange={onChange}
      options={creditAnalystsList}
      placeholder={placeholder}
      sizeVariant="slim"
      value={preSelectedAnalystId}
    />
  );
};
